import { render, staticRenderFns } from "./detail_order.vue?vue&type=template&id=0b4640a6&"
import script from "./detail_order.vue?vue&type=script&lang=js&"
export * from "./detail_order.vue?vue&type=script&lang=js&"
import style0 from "./detail_order.vue?vue&type=style&index=0&id=0b4640a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports